'use client';

import { motion } from 'motion/react';
import Link from 'next/link';

export function ResponsiveFooter() {
  return (
    <motion.footer
      className="w-full bg-zinc-900 bg-opacity-100 border-t border-white/20 mt-auto relative z-50"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-10 lg:gap-4">
          {/* Company Info */}
          <div className="flex flex-col items-center lg:items-start gap-4 flex-1">
            <Link
              href="/"
              className="text-stone-300 font-semibold text-lg sm:text-xl hover:text-white transition-colors cursor-pointer"
            >
              Zumify LLC
            </Link>
            <nav className="flex flex-col items-center lg:items-start gap-3">
              <Link
                href="/about/"
                className="text-stone-300 text-base sm:text-lg lg:text-xl hover:text-white transition-colors cursor-pointer"
              >
                About Us
              </Link>
              <Link
                href="/resources/"
                className="text-stone-300 text-base sm:text-lg lg:text-xl hover:text-white transition-colors cursor-pointer"
              >
                Resources
              </Link>
              <Link
                href="/contact/"
                className="text-stone-300 text-base sm:text-lg lg:text-xl hover:text-white transition-colors cursor-pointer"
              >
                Request Us
              </Link>
            </nav>
          </div>

          {/* Badges (Center) */}
          <div className="flex flex-col items-center gap-3 flex-1">
            <p className="text-[10px] sm:text-xs text-stone-400 uppercase tracking-widest font-semibold text-center">Top Rated in Hawaiʻi</p>
            <div className="flex flex-row items-center justify-center gap-4 sm:gap-6">
              <a href="https://www.designrush.com/agency/mobile-app-design-development?location=236908" target="_blank" rel="noopener noreferrer" className="block cursor-pointer">
                <img 
                  src="/images/Mobile App Development Secondary.webp" 
                  alt="Top Rated Mobile App Development in Hawaii" 
                  className="h-24 sm:h-28 md:h-32 w-auto object-contain hover:scale-105 transition-transform duration-300"
                />
              </a>
              <a href="https://www.designrush.com/agency/web-development-companies/hawaii" target="_blank" rel="noopener noreferrer" className="block cursor-pointer">
                <img 
                  src="/images/Web Design Secondary.webp" 
                  alt="Top Rated Web Design in Hawaii" 
                  className="h-24 sm:h-28 md:h-32 w-auto object-contain hover:scale-105 transition-transform duration-300"
                />
              </a>
            </div>
          </div>

          {/* Logo */}
          <div className="flex justify-center lg:justify-end flex-1">
            <Link
              href="/"
              className="relative w-24 h-24 sm:w-32 sm:h-32 lg:w-40 lg:h-40 flex-shrink-0 cursor-pointer hover:opacity-80 transition-opacity duration-300"
            >
              <div className="absolute inset-0 overflow-hidden">
                <img
                  alt="Zumify Logo"
                  className="absolute left-[-24.32%] max-w-none w-[147.3%] h-[147.3%] top-[-22.97%]"
                  srcSet="/images/zumify-logo-150w.webp 150w, /images/zumify-logo-300w.webp 300w, /images/zumify-logo.webp 500w"
                  sizes="(max-width: 640px) 96px, (max-width: 1024px) 128px, 176px"
                  src="/images/zumify-logo.webp"
                />
              </div>
            </Link>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-8 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-zinc-400">
          <p className="text-center sm:text-left">
            <Link href="/terms/" className="hover:text-white transition-colors">
              Terms of Use
            </Link>{' '}
            &{' '}
            <Link href="/privacy/" className="hover:text-white transition-colors">
              Privacy Policy
            </Link>
          </p>
          <p className="text-center sm:text-right">©2026 Zumify LLC. All Rights Reserved</p>
        </div>
      </div>
    </motion.footer>
  );
}
